import { useState, useCallback } from 'react';

const useSideNav = () => {
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const handleSidenav = useCallback(
    () => setSideNavOpen(s => !s),
    []
  );

  return {
    sideNavOpen,
    handleSidenav
  };
};

export default useSideNav;
